import { render } from "./lipidAnalyzer.vue?vue&type=template&id=4178bfe7&scoped=true"
import script from "./lipidAnalyzer.vue?vue&type=script&lang=js"
export * from "./lipidAnalyzer.vue?vue&type=script&lang=js"

import "./lipidAnalyzer.vue?vue&type=style&index=0&id=4178bfe7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4178bfe7"]])

export default __exports__